// extracted by mini-css-extract-plugin
export default {"hrText":"L3y1DKxpwHxQm_gvrUpg"};